import * as R from 'ramda'

export function safeLowerCase(string: string) {
  return R.is(String, string) ? string.toLowerCase() : String(string).toLowerCase()
}
